
    import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
    import Component from "vue-class-component";
    import {Prop} from "vue-property-decorator";
    import AddQualificationModal from "@/features/documents/qualifications/components/AddQualificationModal.vue";
    import Vue from 'vue';
    import _ from "underscore";
    import Loader from "@/features/shared/components/Loader";
    import LoadingSpinner from "@/components/LoadingSpinner.vue";
    import ConfirmModal from "@/features/shared/components/ConfirmModal.vue";
    import toasts from "@/components/Toasts";
    import userInfo from "@/features/shared/components/UserInfo";
    import FilterCheckbox from "@/components/FilterCheckbox.vue";
    import {NavigationGuardNext} from "vue-router/types/router";
    import {QualificationActions, QualificationsClient, QualificationViewModel, ResultError, SpecialityType, ValidityStatus} from "@/api-client";
    import QualificationTable from "@/features/personProfile/components/QualificationTable.vue";

    class Filters{
        constructor(public institutions:{name: string, id: string}[]) {
        }
        trainingType = false;
        educationalType = false;
        valid = true;
        invalid = false;
        unchecked = true;

        public get isFilteredByType(){
            return this.trainingType || this.educationalType;
        }

        public get isFilteredByStatus(){
            return this.valid || this.invalid || this.unchecked;
        }

        public filter(qualifications: QualificationViewModel[]){
            let filteredByType:QualificationViewModel[] = !this.isFilteredByType ? qualifications : [];
            if(this.trainingType){
                filteredByType = this.addDistinct(filteredByType, qualifications.filter(q => q.specialityType == SpecialityType.Training))
            }
            if(this.educationalType){
                filteredByType = this.addDistinct(filteredByType, qualifications.filter(q => q.specialityType == SpecialityType.Educational))
            }

            let filteredByStatus:QualificationViewModel[] = !this.isFilteredByStatus ? qualifications : [];
            if(this.valid){
                filteredByStatus = this.addDistinct(filteredByStatus, qualifications.filter(q => q.validity == ValidityStatus.Valid))
            }
            if(this.invalid){
                filteredByStatus = this.addDistinct(filteredByStatus, qualifications.filter(q => q.validity == ValidityStatus.Invalid))
            }
            if(this.unchecked){
                filteredByStatus = this.addDistinct(filteredByStatus, qualifications.filter(q => q.validity == ValidityStatus.Unchecked))
            }

            const filteredByInstitutions = this.institutions.length
                ? qualifications.filter(q => this.institutions.some(i => i.name === q.educationalInstitutionName))
                : qualifications;

            return filteredByStatus.filter(s => filteredByType.some(t => s.id == t.id)).filter(s => filteredByInstitutions.some(i => i.id == s.id));
        }

        public removeInstitution(institution: { name: string, id: string }){
            this.institutions = _.without(this.institutions, institution);
        }

        private addDistinct(to: QualificationViewModel[], values: QualificationViewModel[]){
            return to.concat(values.filter(v => !to.some(t => t.id == v.id)));
        }
    }

    interface Props {
        seafarerId: string;
        preLoadedQualifications: QualificationViewModel[];
        preLoadedAvailableActions: QualificationActions;
    }

    @Component({
        components: {
            QualificationTable,
            SectionPageHeading,
            AddQualificationModal,
            LoadingSpinner,
            ConfirmModal,
            FilterCheckbox
        },
        beforeRouteEnter(to, from, next: NavigationGuardNext<QualificationList>) {
            const props = to.meta!.props as Props;
            props.seafarerId = to.params.seafarerId;
            Promise.all([
                new QualificationsClient().list(to.params.seafarerId),
                new QualificationsClient().availableActions(to.params.seafarerId, null)
            ]).then(values => {
                props.preLoadedQualifications = values[0];
                props.preLoadedAvailableActions = values[1];
                next();
            }).catch(e =>  {
                next(e);
            })
        }
    })
    export default class QualificationList extends Vue implements Props {
        @Prop({ required: true})
        seafarerId!: string;
        @Prop({required:true})
        preLoadedQualifications!: QualificationViewModel[];
        @Prop({required:true})
        preLoadedAvailableActions!: QualificationActions;

        qualifications = this.preLoadedQualifications;
        filters = new Filters([]);

        updateLoader = new Loader();

        $refs!: {
            addModal: AddQualificationModal;
        }

        userInfo = userInfo;

        openNewQualificationModal() {
            this.$refs.addModal.open(this.seafarerId);
        }

        get filteredQualifications(){
            return this.filters.filter(this.qualifications);
        }

        get institutions() {
            return _.map(_.groupBy(this.qualifications, q => q.educationalInstitutionName), g => {
                return {name: g[0].educationalInstitutionName}
            });
        }

        async updateFromEHIS(){
            await new QualificationsClient().setLoader(this.updateLoader).updateFromEHIS(this.seafarerId)
                .then(async (count) => {
                    this.qualifications = await new QualificationsClient().list(this.seafarerId);
                    const msg = this.$ls.Documents_Qualifications_Toast_Success_UpdatedFromEHIS.replace("{0}", count.added.toString()).replace("{1}", count.updated.toString());
                    toasts.success(msg);
                })
                .catch(error => {
                    (error as ResultError).messagesFlattened.forEach(message => toasts.failure(message));
                });
        }
    }
